import { lazy, Suspense, useEffect } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import {
  isStaleAssetError,
  requestRequiredAppUpdate,
} from '../../shared/errors/app-update-required'

const AppErrorView = lazy(() =>
  import('../../shared/ui/AppErrorView').then((module) => ({
    default: module.AppErrorView,
  })),
)

function ErrorFallback() {
  return (
    <main className="error-view" role="status">
      <h1>Ошибка загрузки</h1>
    </main>
  )
}

function RequiredUpdateFallback() {
  useEffect(() => requestRequiredAppUpdate(), [])
  return null
}

export function RouteErrorBoundary() {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    return (
      <Suspense fallback={<ErrorFallback />}>
        <AppErrorView
          status={error.status}
          title={
            error.status === 404 ? 'Страница не найдена' : 'Ошибка загрузки'
          }
          description={
            error.status === 404
              ? 'Проверьте адрес или вернитесь на главную страницу.'
              : 'Не удалось открыть этот раздел. Попробуйте ещё раз.'
          }
        />
      </Suspense>
    )
  }

  if (isStaleAssetError(error)) {
    return <RequiredUpdateFallback />
  }

  return (
    <Suspense fallback={<ErrorFallback />}>
      <AppErrorView
        actionLabel="Обновить страницу"
        title="Что-то пошло не так"
        description="Обновите страницу, чтобы загрузить актуальную версию CardReplay."
        onAction={() => window.location.reload()}
      />
    </Suspense>
  )
}
